import {forEach} from "../helpers";
import {item} from "../../components/item/item";
import axios from "axios";

export function catalogItems() {
  const buttonMoreEl = document.querySelector('.js-show-more');
  if (!buttonMoreEl) return;
  const catalogItems = document.querySelector('.catalogItems');
  const catalogListTagClass = '.js-catalog-list';
  const catalogListEl = catalogItems.querySelector(catalogListTagClass);
  let currentPageCount = 1;
  buttonMoreEl.addEventListener('click', () => loadItems());

  function loadItems() {
    if (currentPageCount < Number(catalogListEl.dataset.pageCount)) {
      axios.get(`${location.pathname}page-${++currentPageCount}/${location.search}`, {
        params: {
          [catalogListEl.dataset.ajaxParamName]: catalogListEl.dataset.ajaxComponentId
        }
      })
        .then(response => {
          console.log(response);
          const htmlEl = document.createElement('div');
          htmlEl.innerHTML = String(response.data);
          forEach(htmlEl.querySelector(catalogListTagClass).children, itemEl => {
            catalogListEl.appendChild(itemEl.cloneNode(true));
          });
          forEach(catalogListEl.children, itemEl => {
            item(itemEl.children[0]);
          });
        })
        .catch(error => alert(error));
    } else {
      buttonMoreEl.style.display = 'none';
    }
  }
}
